import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client";
import {
    GetAvailableSitesRequest,
    GetAvailableSitesResponse
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { AsyncResult, useAsync } from "./use-async";

export type { GetAvailableSitesRequest, GetAvailableSitesResponse };

export function useAvailableSites({
    orderId,
    transactionAccount
}: GetAvailableSitesRequest): AsyncResult<GetAvailableSitesResponse> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            stargateClient.getAvailableSites({
                orderId,
                transactionAccount
            }),
        []
    );
}
